import * as React from 'react';
import { useFragment } from 'react-relay';
import { cutOffTableHeaderFragment } from './CutOffTableHeader.relay';
import type { CutOffTableHeaderPropsType } from './types';

const CutOffTableHeader: React.FC<CutOffTableHeaderPropsType> = ( props: CutOffTableHeaderPropsType ) => {
    const header = useFragment( cutOffTableHeaderFragment, props.header );

    if ( typeof props.getHeaderCallback === 'function' ) {
        props.getHeaderCallback( header.tableHeader );
    }

    return (
        <thead>
            <tr>
                {header.tableHeader.map( ( headerItem, index ) => (
                    <th
                        key={ index }
                        className={ `TableHeaderCell-${ headerItem.col } ${ headerItem.col === 'FundName' ? 'max-[1100px]:block max-[1100px]:w-[70%] max-[560px]:w-full' : '' } ${ headerItem.col === 'Isin' ? 'max-[1100px]:block max-[1100px]:w-[30%] max-[560px]:hidden' : '' } ${ [ 'Currency', 'Frequency', 'FrequencyComment', 'CutOffTime', 'ValueDate' ].includes( headerItem.col ) ? 'max-[1100px]:hidden' : '' }` }
                    >
                        <div>
                            {headerItem.label}
                        </div>
                    </th>
                ) )}
            </tr>
        </thead>
    );
};

export { CutOffTableHeader };
